import React, { useEffect, useRef, useState } from "react";
import SearchBar from "../../atom/search";
import {
  CheckIcon,
  CopyIcon,
  CsvIcon,
  DownArrow,
  EnableAllIconDown,
  EnableAllIconUp,
  ErrorIcon,
  EyeIcon,
  FilterIcon,
  SelectAllIcon,
  TableSortIconDownArrow,
  TickIcon,
  UpArrow,
  ZipCrunch,
} from "../../utils/icons/defaultIcons";
import FadeIn from "react-fade-in";
import ThemedButton from "../../atom/ThemedButton/themedButton";
import CheckPermission from "../../services/permission";
import Loader from "../loader";
import ToggleButton from "../../atom/toggleButton";
import CustomTooltip from "../../atom/customTooltip";
import { Tooltip } from "@mui/material";
const ProgressCircle = ({ percentage }: { percentage: number }) => {
  return (
    <div className="relative flex items-center justify-center">
      {/* Circle */}
      <div
        className="h-[18px] w-[18px] border border-primary rounded-full"
        style={{
          background: `conic-gradient(var(--theme-primary) ${percentage}%, #fff 0)`,
        }}
      ></div>

      {/* Inner Text */}
      <div className="relative text-center">
        <span className="text-xs ml-2 text-[gray]">{percentage}%</span>
      </div>
    </div>
  );
};
function TableTopBar(props: any) {
  const {
    showDropdownValues,
    setHideDropdownValues,
    title,
    titleClass,
    CSV = false,
    csvDownload = false,
    copy = false,
    search = true,
    search_class,
    button = false,
    button2 = false,
    button3 = false,
    toggle = false,
    toggleChecked,
    buttonText,
    buttonText2,
    buttonText3,
    CSVDropdown,
    setManageState,
    permission = "",
    searchtext,
    setSearchText,
    handleSearch,
    handleKeyPress,
    setHandleKeyPress,
    onhandleStateChange,
    handleCSVDownload,
    actionHandler,
    zipCrunch = false,
    zipCrunchDD = [],
    handleZipCrunch,
    exportLoader,
    toggleDropdown,
    handleToggleChange,
    zipflag = false,
    enableAll = false,
    buttonDropdown = false,
    buttonDropdownList = [],
    zipCrunchMode = "single",
  } = props;

  const modalRef = useRef<HTMLInputElement>(null);
  const toggleRef = useRef<HTMLInputElement>(null);
  const modalZipRef = useRef<HTMLInputElement>(null);
  const modalCSVRef = useRef<HTMLInputElement>(null);
  const buttonDropdownRef = useRef<HTMLDivElement>(null);

  const [hideDropdown, setHideDropdown] = useState<boolean>(false);
  const [selectToggleDropdown, setSelectToggleDropdown] =
    useState<boolean>(false);
  const [CSVDropdownList, SetCSVDropdownList] = useState<boolean>(false);
  const [hideCount, setHideCount] = useState<number>(0);
  const [hideZipCrunchDropdown, SethideZipCrunchDropdown] =
    useState<boolean>(false);
  const [buttonDropdownOpen, setButtonDropdownOpen] = useState<boolean>(false);
  const indeterminateRef = useRef<any>(null);
  const dropdownFilterUpdate = (node: any, index: number) => {
    let dummyData = [...showDropdownValues];
    var fIndex = dummyData.findIndex((itm: any) => node.key === itm.key);
    dummyData[fIndex].hide.status =
      node?.hide.default === true ? true : !dummyData[fIndex]?.hide.status;
    setHideDropdownValues(dummyData);
  };

  const handleActionButton = (action: string) => {
    console.log("first,", action);
    actionHandler(action);
  };

  const filterDropdown = (filter: string) => {
    if (filter === "showall") {
      // debugger
      let dummyData = [...showDropdownValues];
      var flag = true;
      var expLen = dummyData.filter(
        (node: any) => node?.hide?.status !== undefined,
      ).length;
      var actLen = dummyData.filter(
        (node: any) => node?.hide?.status === true,
      ).length;
      if (expLen === actLen) {
        flag = false;
      }
      dummyData
        .filter((node: any) => node?.hide)
        .forEach((node: any) => {
          node.hide.status = node.hide.default === true ? true : flag;
        });
      setHideDropdownValues(dummyData);
      setHideCount(0);
    }
  };

  const handleToggleAll = (data: any) => {
    // console.log("togglealldata", data);
    handleToggleChange(data);
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (toggleRef.current && !toggleRef.current.contains!(event.target)) {
        setSelectToggleDropdown(false);
      }
      if (modalRef.current && !modalRef.current.contains!(event.target)) {
        setHideDropdown(false);
      }
      if (modalZipRef.current && !modalZipRef.current.contains!(event.target)) {
        SethideZipCrunchDropdown(false);
      }
      if (modalCSVRef.current && !modalCSVRef.current.contains!(event.target)) {
        SetCSVDropdownList(false);
      }
      if (
        buttonDropdownRef.current &&
        !buttonDropdownRef.current.contains!(event.target)
      ) {
        setButtonDropdownOpen(false);
      }
    };

    // Attach the event listener to the document
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up the event listener when the component is unmounted
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [hideDropdown]);

  useEffect(() => {
    // console.log("showDropdownValues", showDropdownValues)
    if (showDropdownValues !== undefined) {
      const len = showDropdownValues.filter(
        (item: any) => item?.hide?.status === true,
      ).length;
      const total = showDropdownValues.filter((node: any) => node?.hide).length;
      setHideCount(len);
    }
  }, [showDropdownValues]);

  const onHandleClick = (text: string) => {
    if (text === "Provision new user") {
      setManageState("newUserProvision");
      onhandleStateChange("provisionuser");
    } else if (text === "Add Tenant") {
      onhandleStateChange("addTenant");
    }

    handleActionButton(text);
  };

  return (
    // <div
    //   data-testid="tableTopBar"
    //   className={`flex px-4 relative text justify-between`}
    // >
    <div className="">
      <div
        data-testid="tableTopBar"
        className="flex flex-col md:flex-row px-4 relative justify-between md:items-center gap-4 w-full"
      >
        <div
          className={`font-bold ${
            titleClass ? titleClass : "text-[18px]"
          }  flex items-center`}
        >
          {title}
          {toggle && (
            <ToggleButton
              click={() => actionHandler("toggleclick")}
              checked={toggleChecked}
            />
          )}
        </div>

        {search === true && (
          <div
            className={`flex items-center justify-center w-full md:w-[300px] lg:w-[400px] ${search_class}`}
          >
            <SearchBar
              placeholder={"Search..."}
              searchtext={searchtext}
              setSearchText={setSearchText}
              handleSearch={handleSearch}
              handleKeyPress={handleKeyPress}
              setHandleKeyPress={setHandleKeyPress}
            />
          </div>
        )}

        <div className="flex flex-wrap items-center gap-3 justify-end">
          <div className="flex items-center justify-end ">
            {copy && (
              <div className="flex svg-fill-primary justify-center items-center gap-1.5 rounded-lg p-1 cursor-pointer hover:bg-ternary">
                <span>
                  <CopyIcon />
                </span>
                <span>Copy</span>
              </div>
            )}
            {toggleDropdown !== undefined && (
              <div ref={toggleRef} className="relative">
                <div
                  className="cursor-pointer "
                  onClick={() => {
                    setSelectToggleDropdown(!selectToggleDropdown);
                    setHideDropdown(false);
                  }}
                >
                  {selectToggleDropdown ? (
                    // <div>
                    <span>
                      <EnableAllIconUp />
                    </span>
                  ) : (
                    // </div>
                    // <div>
                    <Tooltip title="More Options">
                      <span>
                        <EnableAllIconDown />
                      </span>
                    </Tooltip>
                    // </div>
                  )}
                </div>
                {selectToggleDropdown && (
                  <div className="absolute w-[280px] h-fit z-50 top-12 -right-1 space-y-1  rounded-md border border-[#89898957] bg-[#FFFFFF]  px-1 py-2 ">
                    <FadeIn>
                      {toggleDropdown?.map((node: any) => {
                        return (
                          <div
                            key={node.title}
                            className="py-2 pl-2 hover:bg-ternary cursor-pointer rounded-sm flex justify-between items-center"
                          >
                            {node.title}
                            <ToggleButton
                              click={() => handleToggleAll(node)}
                              checked={node.checked}
                            />
                          </div>
                        );
                      })}
                    </FadeIn>
                  </div>
                )}
              </div>
            )}

            {showDropdownValues !== undefined && (
              <div ref={modalRef} className="relative">
                <div
                  id={"hide_columns_icon"}
                  className="flex cursor-pointer items-center justify-evenly px-2 "
                  onClick={() => {
                    setHideDropdown(!hideDropdown);
                    setSelectToggleDropdown(false);
                  }}
                >
                  <span
                    className={`mt-0.5 ${
                      showDropdownValues?.filter(
                        (node: any) => node?.hide?.status === false,
                      ).length !== 0
                        ? "svg-fill-primary"
                        : ""
                    }`}
                  >
                    <Tooltip title="Manage Columns">
                      <svg
                        width="26"
                        height="26"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20.851 4.71363L6.15012 4.71362C4.41268 4.71362 2.75394 6.42943 2.75394 8.18749V18.8126C2.75394 20.5707 4.41268 22.2666 6.15012 22.2666H20.851C22.5885 22.2666 24.2087 20.5707 24.2087 18.8126V8.18746C24.2097 6.4294 22.5875 4.71363 20.851 4.71363ZM16.2797 6.25761V20.694H10.3505V6.25761H16.2797ZM4.18458 18.8126V8.18749C4.18458 7.0141 4.99053 6.25761 6.15012 6.25761H8.75394V20.694H6.15012C4.9905 20.694 4.18458 19.9869 4.18458 18.8126ZM22.7524 18.8126C22.7524 19.986 22.0106 20.694 20.851 20.694H17.701V6.25761L20.851 6.32642C22.0107 6.32642 22.7524 7.0141 22.7524 8.18746V18.8126Z"
                          fill="black"
                        />
                      </svg>
                    </Tooltip>
                  </span>
                </div>

                {/* {hideDropdown && */}
                {hideDropdown && (
                  <div className="absolute w-[250px] h-fit z-50 top-12 -right-1 space-y-1  rounded-md border border-[#89898957] bg-[#FFFFFF]  px-1 py-2">
                    <FadeIn>
                      <div
                        className="hover:bg-ternary rounded-sm py-2 flex justify-between cursor-pointer"
                        onClick={() => filterDropdown("showall")}
                      >
                        <span className="ml-2">All</span>
                        <span className="mr-2 ">
                          <input
                            checked={
                              showDropdownValues.filter(
                                (node: any) => node?.hide?.status !== undefined,
                              ).length ===
                              showDropdownValues.filter(
                                (node: any) => node?.hide?.status === true,
                              ).length
                            }
                            type="checkbox"
                            className="w-4 h-4  rounded-lg cursor-pointer accent-[#F78F1E]"
                          />
                        </span>
                      </div>
                      <hr className="mt-1" />
                      {showDropdownValues
                        ?.filter((node: any) => node?.hide)
                        .map((node: any, index: number) => {
                          return (
                            <>
                              <div
                                className="hover:bg-ternary rounded-sm py-2 flex justify-between cursor-pointer"
                                onClick={() =>
                                  dropdownFilterUpdate(node, index)
                                }
                              >
                                <span className="ml-2">{node.title}</span>
                                <span className="mr-2">
                                  <input
                                    type="checkbox"
                                    disabled={node?.hide.default}
                                    value=""
                                    checked={node?.hide.status}
                                    className="w-4 h-4  rounded-lg cursor-pointer accent-[#F78F1E]"
                                  />
                                </span>
                              </div>
                            </>
                          );
                        })}
                    </FadeIn>
                  </div>
                )}
              </div>
            )}
            {CSV && (
              <div ref={modalCSVRef} className="relative">
                <div
                  onClick={() =>
                    CSVDropdown
                      ? SetCSVDropdownList(!CSVDropdownList)
                      : csvDownload
                        ? null
                        : handleCSVDownload()
                  }
                  className={`flex w-[24px]  ${
                    csvDownload
                      ? "animate-pulse svg-fill-primary cursor-wait"
                      : " cursor-pointer"
                  }   justify-center items-center gap-1.5 rounded-lg p-1 `}
                >
                  <span className=" w-[24px] flex content-center items-center justify-center  text-center">
                    {csvDownload ? (
                      <Loader size="sm" />
                    ) : (
                      <Tooltip title="Export as CSV">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20.25 10.5001V19.5001C20.25 19.8979 20.092 20.2795 19.8107 20.5608C19.5294 20.8421 19.1478 21.0001 18.75 21.0001H5.25C4.85218 21.0001 4.47064 20.8421 4.18934 20.5608C3.90804 20.2795 3.75 19.8979 3.75 19.5001V10.5001C3.75 10.1023 3.90804 9.72075 4.18934 9.43944C4.47064 9.15814 4.85218 9.0001 5.25 9.0001H7.5C7.69891 9.0001 7.88968 9.07912 8.03033 9.21977C8.17098 9.36042 8.25 9.55119 8.25 9.7501C8.25 9.94901 8.17098 10.1398 8.03033 10.2804C7.88968 10.4211 7.69891 10.5001 7.5 10.5001H5.25V19.5001H18.75V10.5001H16.5C16.3011 10.5001 16.1103 10.4211 15.9697 10.2804C15.829 10.1398 15.75 9.94901 15.75 9.7501C15.75 9.55119 15.829 9.36042 15.9697 9.21977C16.1103 9.07912 16.3011 9.0001 16.5 9.0001H18.75C19.1478 9.0001 19.5294 9.15814 19.8107 9.43944C20.092 9.72075 20.25 10.1023 20.25 10.5001ZM8.78063 6.53073L11.25 4.06041V12.7501C11.25 12.949 11.329 13.1398 11.4697 13.2804C11.6103 13.4211 11.8011 13.5001 12 13.5001C12.1989 13.5001 12.3897 13.4211 12.5303 13.2804C12.671 13.1398 12.75 12.949 12.75 12.7501V4.06041L15.2194 6.53073C15.3601 6.67146 15.551 6.75052 15.75 6.75052C15.949 6.75052 16.1399 6.67146 16.2806 6.53073C16.4214 6.39 16.5004 6.19912 16.5004 6.0001C16.5004 5.80108 16.4214 5.61021 16.2806 5.46948L12.5306 1.71948C12.461 1.64974 12.3783 1.59443 12.2872 1.55668C12.1962 1.51894 12.0986 1.49951 12 1.49951C11.9014 1.49951 11.8038 1.51894 11.7128 1.55668C11.6217 1.59443 11.539 1.64974 11.4694 1.71948L7.71937 5.46948C7.57864 5.61021 7.49958 5.80108 7.49958 6.0001C7.49958 6.19912 7.57864 6.39 7.71938 6.53073C7.86011 6.67146 8.05098 6.75052 8.25 6.75052C8.44902 6.75052 8.63989 6.67146 8.78063 6.53073Z"
                            fill="#293241"
                          />
                        </svg>
                      </Tooltip>
                    )}
                  </span>
                </div>
                {CSVDropdownList && (
                  <div className="absolute w-[250px] h-fit z-50 top-10 -right-1 space-y-1  rounded-md border border-[#89898957] bg-[#FFFFFF]  px-1 py-2 ">
                    <FadeIn>
                      {CSVDropdown.map((node: any, index: number) => {
                        return (
                          <div
                            className="p-2 flex justify-between cursor-pointer  hover:bg-[#F5F5F5]"
                            key={index}
                            onClick={() => {
                              handleCSVDownload(node);
                            }}
                          >
                            {node.title}
                            {node.loading ? (
                              <div className="m-[-2px] mx-[-8px]">
                                <Loader size="sm" />
                              </div>
                            ) : (
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M20.25 10.5001V19.5001C20.25 19.8979 20.092 20.2795 19.8107 20.5608C19.5294 20.8421 19.1478 21.0001 18.75 21.0001H5.25C4.85218 21.0001 4.47064 20.8421 4.18934 20.5608C3.90804 20.2795 3.75 19.8979 3.75 19.5001V10.5001C3.75 10.1023 3.90804 9.72075 4.18934 9.43944C4.47064 9.15814 4.85218 9.0001 5.25 9.0001H7.5C7.69891 9.0001 7.88968 9.07912 8.03033 9.21977C8.17098 9.36042 8.25 9.55119 8.25 9.7501C8.25 9.94901 8.17098 10.1398 8.03033 10.2804C7.88968 10.4211 7.69891 10.5001 7.5 10.5001H5.25V19.5001H18.75V10.5001H16.5C16.3011 10.5001 16.1103 10.4211 15.9697 10.2804C15.829 10.1398 15.75 9.94901 15.75 9.7501C15.75 9.55119 15.829 9.36042 15.9697 9.21977C16.1103 9.07912 16.3011 9.0001 16.5 9.0001H18.75C19.1478 9.0001 19.5294 9.15814 19.8107 9.43944C20.092 9.72075 20.25 10.1023 20.25 10.5001ZM8.78063 6.53073L11.25 4.06041V12.7501C11.25 12.949 11.329 13.1398 11.4697 13.2804C11.6103 13.4211 11.8011 13.5001 12 13.5001C12.1989 13.5001 12.3897 13.4211 12.5303 13.2804C12.671 13.1398 12.75 12.949 12.75 12.7501V4.06041L15.2194 6.53073C15.3601 6.67146 15.551 6.75052 15.75 6.75052C15.949 6.75052 16.1399 6.67146 16.2806 6.53073C16.4214 6.39 16.5004 6.19912 16.5004 6.0001C16.5004 5.80108 16.4214 5.61021 16.2806 5.46948L12.5306 1.71948C12.461 1.64974 12.3783 1.59443 12.2872 1.55668C12.1962 1.51894 12.0986 1.49951 12 1.49951C11.9014 1.49951 11.8038 1.51894 11.7128 1.55668C11.6217 1.59443 11.539 1.64974 11.4694 1.71948L7.71937 5.46948C7.57864 5.61021 7.49958 5.80108 7.49958 6.0001C7.49958 6.19912 7.57864 6.39 7.71938 6.53073C7.86011 6.67146 8.05098 6.75052 8.25 6.75052C8.44902 6.75052 8.63989 6.67146 8.78063 6.53073Z"
                                  fill="#999"
                                />
                              </svg>
                            )}
                          </div>
                        );
                      })}
                    </FadeIn>
                  </div>
                )}
              </div>
            )}
            {zipCrunch && (
              <div ref={modalZipRef} className="relative">
                <CustomTooltip
                  title={`${
                    zipflag ? "Export in progress" : "Export to ZipCrunch"
                  }`}
                >
                  <div
                    onClick={() =>
                      SethideZipCrunchDropdown(!hideZipCrunchDropdown)
                    }
                    className={`ml-4 cursor-pointer p-0.5  ${
                      zipflag &&
                      "animate-pulse border rounded-full border-[#F78F1E] "
                    }`}
                  >
                    <ZipCrunch />
                  </div>
                </CustomTooltip>
                {hideZipCrunchDropdown && (
                  <div className="absolute w-[250px] h-fit z-50 top-11 -right-2 space-y-1  rounded-md border border-[#89898957] bg-[#FFFFFF]  px-1 py-2 ">
                    <FadeIn>
                      <div className="border-b p-1 px-3 -mx-1 mb-2 border-[#89898957] flex justify-between items-center">
                        <span className="font-semibold text-gray-700">
                          Export by Carrier
                        </span>
                      </div>
                      {zipCrunchDD.length === 0 ? (
                        <div className="text-[#aaa] text-center text-sm p-4">
                          No carriers found to export
                        </div>
                      ) : (
                        (() => {
                          const allCarrier = zipCrunchDD.find(
                            (n: any) => n.carrier === "All",
                          );
                          const selectedCount = zipCrunchDD.filter(
                            (n: any) => n.carrier !== "All" && n.checked,
                          ).length;
                          const isCombineEnabled = selectedCount > 1;

                          return (
                            <>
                              <div className="max-h-[220px] overflow-y-auto px-1 -mx-1 scrollbar-thin scrollbar-thumb-gray-200 hover:scrollbar-thumb-gray-300">
                                {[...zipCrunchDD]
                                  .filter((n: any) => n.carrier !== "All")
                                  .map((node: any, index: number) => {
                                    return (
                                      <div
                                        key={index}
                                        className={`${
                                          node.status === "completed" ||
                                          node.status === "progress"
                                            ? "bg-primary-alpha-20"
                                            : "hover:bg-ternary"
                                        }  rounded-lg py-2 px-3 flex items-center justify-between mb-0.5 group transition-all duration-200 cursor-pointer`}
                                        onClick={() =>
                                          handleZipCrunch(node, "toggle")
                                        }
                                      >
                                        <div className="flex items-center space-x-2">
                                          <span className="text-[13px] text-gray-700 font-medium group-hover:text-gray-900 transition-colors">
                                            {node.carrier}
                                          </span>
                                          {node.status === "completed" && (
                                            <div className="text-green-500 scale-75">
                                              <CheckIcon />
                                            </div>
                                          )}
                                          {node.status === "progress" && (
                                            <div className="scale-75">
                                              <ProgressCircle
                                                percentage={
                                                  node?.percentage === 100
                                                    ? 99
                                                    : Math.round(
                                                        node?.percentage,
                                                      ) || 0
                                                }
                                              />
                                            </div>
                                          )}
                                        </div>

                                        <span className="flex items-center">
                                          {node.status === "failed" ? (
                                            <div className="flex items-center space-x-1.5">
                                              <CustomTooltip title="Error Occurred, Click to retry">
                                                <div className="text-red-500 scale-90">
                                                  <ErrorIcon />
                                                </div>
                                              </CustomTooltip>
                                              <input
                                                type="checkbox"
                                                value=""
                                                checked={node?.checked || false}
                                                className="w-4 h-4 rounded-md cursor-pointer accent-primary border-gray-300"
                                              />
                                            </div>
                                          ) : (
                                            <input
                                              type="checkbox"
                                              value=""
                                              checked={node?.checked || false}
                                              className="w-4 h-4 rounded-md cursor-pointer accent-primary border-gray-300"
                                            />
                                          )}
                                        </span>
                                      </div>
                                    );
                                  })}
                              </div>

                              <hr className="my-1 mb-2 mt-3" />
                              <div className="pt-2">
                                {allCarrier && (
                                  <div className="px-1 mb-3">
                                    <CustomTooltip
                                      placement="bottom"
                                      title={
                                        !isCombineEnabled
                                          ? "Select at least 2 carriers to combine"
                                          : "Combine into single export"
                                      }
                                    >
                                      <div
                                        onClick={() =>
                                          isCombineEnabled &&
                                          handleZipCrunch(allCarrier, "toggle")
                                        }
                                        className={`flex items-center justify-between px-3 py-2.5 rounded-xl transition-all duration-300 border ${
                                          !isCombineEnabled
                                            ? "opacity-40 cursor-not-allowed bg-gray-50 border-gray-100"
                                            : allCarrier.checked
                                              ? "bg-primary-alpha-10 border-primary/20 shadow-inner cursor-pointer"
                                              : "bg-gray-50 border-gray-100 hover:bg-gray-100 hover:border-gray-200 cursor-pointer"
                                        }`}
                                      >
                                        <div className="flex items-center space-x-3">
                                          <div
                                            className={`p-1.5 rounded-lg transition-colors ${
                                              allCarrier.checked &&
                                              isCombineEnabled
                                                ? "bg-primary text-white"
                                                : "bg-gray-200 text-gray-400"
                                            }`}
                                          >
                                            <svg
                                              width="14"
                                              height="14"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="currentColor"
                                              strokeWidth="2.5"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            >
                                              <path d="M7 7h10v10H7z" />
                                              <path
                                                d="M11 11h10v10h-10z"
                                                strokeOpacity="0.5"
                                              />
                                              <path
                                                d="M3 3h10v10H3z"
                                                strokeOpacity="0.5"
                                              />
                                            </svg>
                                          </div>
                                          <div className="flex flex-col">
                                            <span
                                              className={`text-[11px] font-bold tracking-tight ${
                                                allCarrier.checked &&
                                                isCombineEnabled
                                                  ? "text-primary"
                                                  : "text-gray-500"
                                              }`}
                                            >
                                              Combine Carriers
                                            </span>
                                          </div>
                                        </div>
                                        <div
                                          className={`w-9 h-5 rounded-full relative transition-colors duration-300 ${
                                            allCarrier.checked &&
                                            isCombineEnabled
                                              ? "bg-primary"
                                              : "bg-gray-300"
                                          }`}
                                        >
                                          <div
                                            className={`absolute top-1 w-3 h-3 rounded-full bg-white shadow-sm transition-all duration-300 ${
                                              allCarrier.checked &&
                                              isCombineEnabled
                                                ? "left-5"
                                                : "left-1"
                                            }`}
                                          />
                                        </div>
                                      </div>
                                    </CustomTooltip>
                                  </div>
                                )}
                                <div className="text-center">
                                  <ThemedButton
                                    children="Export to ZipCrunch"
                                    icon="custom"
                                    theme="primary"
                                    loading={exportLoader}
                                    click={() =>
                                      handleZipCrunch(
                                        zipCrunchDD,
                                        "ZipCrunchSubmit",
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            </>
                          );
                        })()
                      )}
                    </FadeIn>
                  </div>
                )}
              </div>
            )}
          </div>
          <CheckPermission keyParam={permission}>
            {button3 && (
              <div className="" id={`${buttonText3}`}>
                <ThemedButton
                  children={buttonText3}
                  icon="custom"
                  theme="primary"
                  click={() => onHandleClick(buttonText3)}
                />
              </div>
            )}
            {button2 && (
              <div className="" id={`${buttonText2}`}>
                <ThemedButton
                  children={buttonText2}
                  icon="custom"
                  theme="primary"
                  click={() => onHandleClick(buttonText2)}
                />
              </div>
            )}
            {button && !buttonDropdown && (
              <div className="" id={`${buttonText}`}>
                <ThemedButton
                  children={buttonText}
                  icon="custom"
                  theme="primary"
                  click={() => onHandleClick(buttonText)}
                />
              </div>
            )}
            {button && buttonDropdown && (
              <div
                className="relative"
                ref={buttonDropdownRef}
                id={`${buttonText}`}
              >
                <ThemedButton
                  children={
                    <div className="flex items-center gap-2">
                      <span>{buttonText}</span>
                      <TableSortIconDownArrow />
                    </div>
                  }
                  icon="custom"
                  theme="primary"
                  click={() => setButtonDropdownOpen(!buttonDropdownOpen)}
                />
                {buttonDropdownOpen && (
                  <div className="absolute min-w-[200px] w-max h-fit z-50 top-12 right-0 space-y-1 rounded-md border border-[#89898957] bg-[#FFFFFF] px-1 py-1 shadow-md">
                    <FadeIn>
                      {buttonDropdownList.map((node: any, index: number) => (
                        <div
                          key={index}
                          className="hover:bg-ternary rounded-sm py-2 px-3 flex justify-between cursor-pointer text-sm font-medium"
                          onClick={() => {
                            setButtonDropdownOpen(false);
                            onHandleClick(node.title);
                          }}
                        >
                          <span className="">{node.title}</span>
                        </div>
                      ))}
                    </FadeIn>
                  </div>
                )}
              </div>
            )}
          </CheckPermission>
        </div>
      </div>
    </div>
  );
}

export default TableTopBar;
